import {createSelector} from "reselect";
import _ from "lodash";
import {fakeGetSettlementList} from "../demo/others/fakeSettlement";
import {checkIfIsInSettlement} from "../utils/SettlementUtils";
import {SectorType} from "../constans/sectorTypes";
import {isUsingFakeData} from "../utils/DemoUtils";

export const ChamberSettlement = {
    NO_SHOW: 0,
    SHOW_SEPARATION: 1,
    SHOW_SETTLEMENT: 2,
};

export const SettlementNotSupportedSectorTypes = [SectorType.MATING];

export const getFetched = (state) =>
    isUsingFakeData() ? true : state.settlement.fetchedSettlement;

export const getFetching = (state) =>
    isUsingFakeData() ? false : state.settlement.fetchingSettlement;

export const getAllSettlements = (state) =>
    isUsingFakeData()
        ? fakeGetSettlementList(state)
        : state.settlement.settlement;

const getChamberID = (state, props) =>
    typeof props === "string" ? props : props?.CID;

const _getSettlementsChamber = (_cid, _list) => {
    return _cid ? _list.filter((o) => o.PlcmntID === _cid) : [];
};

const getSettlementsChamber = createSelector(
    [getChamberID, getAllSettlements],
    _getSettlementsChamber
);

export const makeGetSettlementsChamber = () =>
    createSelector([getChamberID, getAllSettlements], _getSettlementsChamber);

export const settlementCondition = (data, fetched = true) => {
    return fetched
        ? !_.isFinite(_.get(data, "DtaStartTime")) ||
          (_.isFinite(_.get(data, "DtaEndTime")) &&
              _.get(data, "DtaEndTime") < new Date().getTime())
            ? ChamberSettlement.SHOW_SETTLEMENT
            : ChamberSettlement.SHOW_SEPARATION
        : ChamberSettlement.NO_SHOW;
};

export const getSettlement = createSelector(
    [getSettlementsChamber, getFetched, getFetching],
    (settlementList, fetched, fetching) => {
        const data = _.maxBy(settlementList.slice(0), (o) => o.DtaStartTime);
        return {
            fetched: fetched,
            fetching: fetching,
            data: data,
            state: settlementCondition(data, fetched),
        };
    }
);

export const makeGetCurrentSettlement = () =>
    createSelector([getChamberID, getAllSettlements], (_CID, _List) => {
        return (
            (_CID ? _List.filter((o) => o.PlcmntID === _CID) : [])
                .slice(0)
                .sort((o1, o2) => o1.DtaStartTime - o2.DtaStartTime)
                .filter((o) => checkIfIsInSettlement(o))[0] || null
        );
    });

export const getSettlementList = createSelector(
    [getSettlementsChamber],
    (settlementList) => {
        const result = settlementList.slice(0);
        result.sort((o1, o2) => o1.DtaStartTime - o2.DtaStartTime);
        return result;
    }
);

export const getNewestSettlements = createSelector(
    [getAllSettlements],
    (allSettlementsList) => {
        const result = allSettlementsList.slice(0);
        result.sort((o1, o2) => o2.DtaStartTime - o1.DtaStartTime);
        return _.uniqBy(result, (o) => o.PlcmntID);
    }
);
